import { Button, TextField } from '@material-ui/core'
import api from '../../api/client';
import React, { useState } from 'react'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { toEnglishDigits } from '../../assets/utils'
import { toast } from '../../api/toast'
import { departmentsState } from '../../pages/admin/atoms'
import { loadingState } from '../../recoil/atoms'

const AddDepartment = props => {
    const [departments, setDepartments] = useRecoilState(departmentsState)
    const setLoading = useSetRecoilState(loadingState)

    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [name, setName] = useState('')
    const [nationalCode, setNationalCode] = useState('')

    const addHandler = () => {
        // Validation
        if (!username || !password || !name || !nationalCode) {
            toast('لطفاً همه فیلدها را پر کنید')
            return
        }

        setLoading(true)
        api.post('users/departments/', {
            username: toEnglishDigits(username),
            password: toEnglishDigits(password),
            name: toEnglishDigits(name),
            national_code: toEnglishDigits(nationalCode)
        }).then(response => {
            if (response.status === 201) {
                // اضافه کردن سازمان جدید به لیست
                setDepartments([...departments, response.data])
                // بستن دیالوگ
                props.setOpenAddDepartment(false)
            }
            setLoading(false)
        }).catch(error => {
            setLoading(false)
            if (error.response && error.response.status === 409) {
                toast('نام کاربری یا شناسه ملی تکراری است')
            } else {
                toast('خطا در افزودن سازمان')
            }
        })
    }

    return (
        <>
            <TextField
                margin='normal'
                label="نام کاربری"
                variant='outlined'
                fullWidth
                dir='ltr'
                autoComplete='off'
                value={username}
                onChange={event => setUsername(event.target.value)}
            />
            <TextField
                margin='normal'
                label="کلمه عبور"
                variant='outlined'
                fullWidth
                autoComplete='off'
                type='password'
                dir='ltr'
                value={password}
                onChange={event => setPassword(event.target.value)}
            />
            <TextField
                margin='normal'
                label="عنوان"
                variant='outlined'
                fullWidth
                value={name}
                autoComplete='off'
                onChange={event => setName(event.target.value)}
            />
            <TextField
                margin='normal'
                label="شناسه ملی"
                variant='outlined'
                autoComplete='off'
                fullWidth
                value={nationalCode}
                onChange={event => setNationalCode(event.target.value)}
            />
            <Button
                variant='contained'
                color='primary'
                onClick={() => addHandler()}
            >
                ذخیره
            </Button>
            <Button
                variant='contained'
                color='primary'
                style={{ marginRight: '10px' }}
                onClick={() => props.setOpenAddDepartment(false)}
            >
                انصراف
            </Button>
        </>
    )
}

export default AddDepartment